<template>
    <v-row class="mx-0 justify-center">
        <div class="py-3 px-1"
             :class="{'catalogue-card-wrapper': useWrapperClass}"
             v-for="product in products" :key="product.id"
        >
            <product-card
                    class="general_card"
                    :product="product"
                    :filter-key="filterKey"
                    @snack-bar="snackBar"
            ></product-card>
        </div>
        <div class="py-3 px-1"
             :class="{'catalogue-card-wrapper': useWrapperClass}"
             v-if="loading" v-for="i in 8" :key="i"
        >
            <v-skeleton-loader
                min-width="150px"
                class="mb-3 px-1"
                type="card, list-item-three-line, actions"
            ></v-skeleton-loader>
        </div>
        <v-col cols="12" class="my-7" v-if="products.length && showPagination">
            <v-row class="justify-center">
                <v-col cols="12" sm="auto" class="d-flex flex-column justify-center">
                    <v-btn
                        v-if="currentPage !== lastPage && isVisibleMoreButton"
                        dark
                        depressed
                        block
                        class="px-5 caption"
                        color="main--yellow"
                        @click="$emit('show-more')"
                    >
                        {{ $t('seeMore') }}
                    </v-btn>

                    <v-pagination
                        v-if="lastPage !== 1"
                        v-model.number="currentPage"
                        :length="lastPage"
                        :total-visible="totalVisible"
                        :class="{'pt-5': isVisibleMoreButton}"
                        prev-icon="mdi-menu-left"
                        next-icon="mdi-menu-right"
                        color="main--yellow"
                        @input="changePage"
                    ></v-pagination>
                </v-col>
            </v-row>
        </v-col>
        <price-dialog
                :is-open="priceMessageOpen"
                :product="priceMessageProduct"
                @close="priceMessageOpen = false"
        ></price-dialog>
        <seller-dialog
                :isOpen="sellerMessageOpen"
                :product="sellerMessageProduct"
                @close="sellerMessageOpen = false"
        ></seller-dialog>
        <auth-dialog :is-open="loginDialogStore"></auth-dialog>
    </v-row>
</template>

<script>
    import AuthDialog from '../../dialogs/AuthDialog';
    import PriceDialog from '../../dialogs/ProductPriceDialog';
    import ProductCard from '../general-card/GeneralCard';
    import SellerDialog from '../../dialogs/ProductSellerDialog';

    import './product-list.scss'

    export default {
        name: "ProductList",
        props: {
            products: {
                required: false,
                type: Array,
                default: () => []
            },
            total: {
                required: false,
                type: Number,
                default: 0
            },
            lastPage: {
                required: false,
                type: Number,
                default: 1
            },
            initPage: {
                required: false,
                type: Number,
                default: 1
            },
            totalVisible: {
                required: false,
                type: Number,
                default: 7
            },
            filterCardKey: {
                required: false,
                type: String,
                default: ''
            },
            loading: {
                required: false,
                type: Boolean,
                default: false
            },
            isVisibleMoreButton: {
                required: false,
                type: Boolean,
                default: true
            },
            useWrapperClass: {
                required: false,
                type: Boolean,
                default: true
            },
            showPagination: {
                required: false,
                type: Boolean,
                default: true
            },
        },
        components: {AuthDialog, PriceDialog, ProductCard, SellerDialog},
        data() {
            return {
                priceMessageOpen: false,
                priceMessageProduct: null,
                sellerMessageOpen: false,
                sellerMessageProduct: null,
                sortBy: [
                    {id:1, name:this.$t('byRating')},
                    {id:2, name:this.$t('cheap')},
                    {id:3, name:this.$t('expensive')},
                    {id:4, name:this.$t('byDate')},
                ],
                currentPage: 1,
            }
        },
        computed: {
            loginDialogStore() {
                return this.$store.state.account.showLoginDialog;
            },
            filterKey() {
                return this.filterCardKey || 'category';
            }
        },
        methods: {
            changePage(page) {
                this.$emit('change-page', page);
                window.scrollTo(0, 0);
            },
            priceMessage(product) {
                this.priceMessageProduct = product;
                this.priceMessageOpen = true;
            },
            sellerMessage(product) {
                this.sellerMessageProduct = product;
                this.sellerMessageOpen = true;
            },
            snackBar(id){
                this.$emit('snack-bar', id);
            }
        },
        watch: {
            initPage: {
                handler(val) {
                    this.currentPage = val;
                },
                immediate: true
            },
            currentPage: {
                handler(page) {
                    const paramName = 'page';
                    const {protocol, host, pathname, search} = window.location;
                    const urlParams = new URLSearchParams(search);
                    urlParams.delete(paramName);

                    if (page > 1) {
                        urlParams.append(paramName, page);
                    }

                    const params = urlParams.toString() ? '?' + urlParams.toString() : '';
                    const path = `${protocol}//${host}${pathname}${params}`;
                    window.history.pushState({ path }, '', path);
                },
                immediate: true
            },
        }
    }
</script>

<style scoped>
    .v-pagination {
        width: initial;
    }
</style>
